import moment from "moment";

export const generateGetters = (keys) => {
  const getters = {};

  keys.forEach((key) => {
    getters[key] = (state) => state[key];
  });

  return getters;
};

export function detectSkuNotMatch(item) {
  if (!item) return false;
  if (item.skuNotMatch) return true;

  const statusMessage = String(item.statusMessage || "").toLowerCase();
  if (
    statusMessage.includes("sku does not match") ||
    statusMessage.includes("sku-not-match")
  ) {
    return true;
  }

  if (!item.statusMessages) return false;

  const messages = Array.isArray(item.statusMessages)
    ? item.statusMessages
    : [item.statusMessages];

  return messages.some((msg) => String(msg).includes("sku-not-match"));
}

export function isImportEditCloneDisabled(item) {
  if (!item) return false;

  const discountType = item.discountType ?? item.DiscountType;
  if (Number(discountType) !== 3) return false;

  const cutoffDate = process.env.VUE_APP_DISABLE_PAST_RECORD;
  if (!cutoffDate) return false;

  const cutoff = moment(String(cutoffDate).trim(), ["YYYY-MM-DD", "YYYY_MM-DD"], true);
  if (!cutoff.isValid()) return false;

  const lastEdit = moment(item.lastEditTime, "MM/DD/YYYY HH:mm:ss", true);
  if (!lastEdit.isValid()) return false;

  return lastEdit.isBefore(cutoff, "day");
}
